import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

/**
 * Setup/magic icon — a four-point sparkle with a trailing handle, used to
 * indicate a guided setup action (e.g. the "Set up your Board View" banner).
 */
@Component({
  selector: 'lib-setup-magic-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round">
      <path
        d="M14.4082 3.45081L14.3499 6.60912C14.3415 7.04246 14.6166 7.61747 14.9666 7.87581L17.0332 9.44245C18.3582 10.4425 18.1416 11.6675 16.5582 12.1675L13.8666 13.0091C13.4166 13.1508 12.9416 13.6425 12.8249 14.1008L12.1832 16.5508C11.6749 18.4841 10.4082 18.6758 9.35821 16.9758L7.89154 14.6008C7.62487 14.1675 6.99154 13.8425 6.49154 13.8675L3.70824 14.0091C1.71657 14.1091 1.1499 12.9591 2.4499 11.4425L4.09988 9.52579C4.40821 9.16746 4.54988 8.5008 4.40821 8.0508L3.56659 5.35912C3.07492 3.77579 3.95824 2.9008 5.53324 3.41747L7.99158 4.2258C8.40825 4.35914 9.03324 4.26746 9.38324 4.00913L11.9499 2.15913C13.3333 1.15913 14.4415 1.74248 14.4082 3.45081Z" />
      <path d="M18.2574 18.3336L15.7324 15.8086" />
    </svg>
  `,
})
export class SetupMagicIconComponent extends BaseIconComponent {
  override width = input<string>('20');
  override height = input<string>('20');
  override viewBox = input<string>('0 0 20 20');
}
